(function () {
  function initSpecScroll(region) {
    var step = parseInt(region.getAttribute('data-scroll-step'), 10) || 190;

    region.addEventListener('keydown', function (event) {
      if (region.scrollWidth <= region.clientWidth) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      event.preventDefault();
      region.scrollBy({
        left: event.key === 'ArrowRight' ? step : -step,
        behavior: 'smooth',
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-th-spec-scroll]').forEach(initSpecScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-th-spec-scroll]').forEach(initSpecScroll);
  });
})();
